import { HTMLTERM } from "./Termo-de-Uso-e-Privacidade-de-Dados-Axyma-converted";


export default function PrivacyTerms() {
  return (
    <div dangerouslySetInnerHTML={{ __html: HTMLTERM }} style={{ padding: '10px' }}/>
  );
}
